export default __webpack_public_path__ + "static/media/about.01c8cd20.png";